import React from 'react';
import classNames from 'classnames';
import { Button } from '../../Button';
import styles from './Buttons.module.scss';
export var Buttons = function (_a) {
    var _b;
    var _c = _a.verticalButtons, verticalButtons = _c === void 0 ? false : _c, _d = _a.buttons, buttons = _d === void 0 ? [] : _d, closeModal = _a.closeModal;
    return (React.createElement("div", { className: classNames(styles.buttons, (_b = {},
            _b[styles.vertical] = verticalButtons,
            _b)) }, buttons &&
        buttons.map(function (_a, index) {
            var accessibleText = _a.accessibleText, label = _a.buttonText, value = _a.buttonValue, disabled = _a.disabled, onClick = _a.onClick, theme = _a.theme, _b = _a.closeOnClick, closeOnClick = _b === void 0 ? true : _b;
            var handleClick = function (event) {
                if (closeOnClick && closeModal)
                    closeModal({ domEvent: event, value: value, label: label });
                if (onClick)
                    onClick(event);
            };
            return (React.createElement(Button, { "aria-label": accessibleText, disabled: disabled, label: label, theme: theme || (index === buttons.length - 1 ? 'primary' : 'secondary'), value: value, width: verticalButtons ? 'full' : 'standard', key: label, onClick: handleClick }));
        })));
};
//# sourceMappingURL=Buttons.js.map